<template>
    <div class="updateMobile">
        <h2 class="forgetPSText">修改手机号码</h2>
        <div class="form">
            <div class="formItem">
                <p class="tag">现手机验证码</p>
                <input class="input" v-model="code" maxlength="6" type="text" placeholder="请输入现手机的验证码"/>
                <div class="getCodeBtn" @click="getCodeFn('old', 'num')">
                    <span>{{codeText}}</span>
                </div>
            </div>
            <div class="formItem">
                <p class="tag">新手机号码</p>
                <input class="input" type="text" v-model="mobile" placeholder="请输入新手机号码"/>
            </div>
            <div class="formItem">
                <p class="tag">新手机验证码</p>
                <input class="input" v-model="smsCode" maxlength="6" type="text" placeholder="请输入新手机的验证码"/>
                <div class="getCodeBtn" @click="getCodeFn('new', 'newNum')">
                    <span>{{newCodeText}}</span>
                </div>
            </div>
        </div>
        <div class="btn" @click="onSave">
            <span>提交</span>
        </div>
    </div>
</template>

<script>
    /*
    * 修改手机号码
    * */
    import {Button} from 'vant'
    import {getOldSMS, getNewSMS, checkOldSMS, bindNewMobile} from "../../../../api/updateMobile";

    export default {
        name: "UpdateMobile",
        components: {
            Button
        },
        data() {
            return {
                codeText: '获取验证码',
                newCodeText: '获取验证码',
                code: '',
                smsCode: '',
                mobile: '',
                num: 60,
                newNum: 60,
                phoneReg: /^[1][3,4,5,6,7,8,9][0-9]{9}$/,
            }
        },
        methods: {
            getCodeCountdown(fn, codeText, numKey) {
                fn().then(res => {
                    let timer = '';
                    timer = setInterval(() => {
                        if(this[numKey] === 0) {
                            clearInterval(timer);
                            this[codeText] = '获取验证码';
                            this[numKey] = 60;
                        } else {
                            this[codeText] = this[numKey] + ' S';
                            this[numKey]--;
                        }
                    }, 1000);
                })
            },
            getCodeFn(type, NumKey) {
                if(this[NumKey] !== 60) return this.toast({text: `${this[NumKey]}秒后可再次获取`, icon: 'warning'});
                if (type === 'old') {
                    this.getCodeCountdown(getOldSMS, 'codeText', 'num');
                }
                if (type === 'new') {
                    if (!this.code) return this.toast({text: '请输入现手机号码接收到的验证码', icon: 'warning'});
                    if(!this.mobile) return this.toast({text: '请输入新手机号码', icon: 'warning'});
                    if(!this.phoneReg.test(this.mobile)) return this.toast({text: '手机号码格式错误', icon: 'warning'});
                    checkOldSMS(this.code).then(res => {
                        this.getCodeCountdown(_ => {
                            return getNewSMS(this.mobile);
                        }, 'newCodeText', 'newNum');
                    })
                }
            },
            onSave() {
                if (!this.smsCode) return this.toast({text: '请输入新手机号码接收到的验证码', icon: 'warning'});
                let {smsCode, mobile} = this;
                bindNewMobile({smsCode, mobile}).then(res => {
                    this.alert({
                        text: '修改成功',
                        confirmButtonText: '返回',
                        fn: _ => {
                            this.$router.go(-1);
                        }
                    })
                })
            }
        }
    }
</script>

<style lang='less' scoped>
    .updateMobile {
        padding: 0 7vw;
        min-height: 100vh;
        background-color: white;
    }

    .forgetPSText {
        font-size: 5vw;
        color: #1b1b4e;
        line-height: 20vw;
    }

    .tag {
        margin-bottom: 2vw;
        font-size: 3vw;
        color: #3b4664;
    }

    .formItem {
        position: relative;
        margin-bottom: 5vw;
        border-bottom: 1px solid #ededed;
    }

    .input {
        display: block;
        width: 100%;
        border: none;
        height: 10vw;
        padding: 2vw 0;
        line-height: 10vw;
        font-size: 4vw;
        box-sizing: border-box;
        outline: none;
    }

    .input::placeholder {
        color: #AEB3C0;
    }

    .getCodeBtn {
        position: absolute;
        top: 53%;
        right: 0;
        display: flex;
        justify-content: center;
        align-items: center;
        width: 18vw;
        height: 5vw;
        border: solid 1px #49a7f4;
        font-size: 3vw;
        color: #49a7f4;
    }

    .btn {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 85vw;
        height: 11vw;
        margin-top: 13vw;
        font-size: 5vw;
        color: #ffffff;
        background-image: linear-gradient(90deg,
        #31a2fe 0%,
        #4ca8f3 100%),
        linear-gradient(
            #ff6a49,
            #ff6a49);
        background-blend-mode: normal,
        normal;
        box-shadow: 0vw 1vw 3vw 0vw
        rgba(49, 162, 254, 0.39);
        border-radius: 5vw;
    }
</style>



// WEBPACK FOOTER //
// src/page/mine/setting/updateMobile/UpdateMobile.vue